import omit from 'lodash/omit';

import React from 'react';
import PropTypes from 'prop-types';

import InputComponent from './Component';

class InputContainer extends React.PureComponent {
  constructor (props) {
    super(props);

    this.handleOnBlur = event => {
      const { onBlur } = this.props.input;
      const { normalizeValue } = this.props;
      const { value } = event.target;

      if (normalizeValue) {
        onBlur(normalizeValue(value));
      }
    };
  }

  render () {
    const parsedLabel = this.props.label.split('\\n').map(message => <React.Fragment key={message}>{message}<br /></React.Fragment>);

    return (
      <InputComponent
        {...omit(this.props, [
          'meta',
          'input',
          'label'
        ])}
        {...this.props.meta}
        {...this.props.input}
        onBlur={this.handleOnBlur}
        label={parsedLabel}
      />
    );
  }
}

InputContainer.propTypes = {
  label: PropTypes.string,
  input: PropTypes.object.isRequired,
  normalizeValue: PropTypes.func,
  meta: PropTypes.shape({
    invalid: PropTypes.bool.isRequired,
    touched: PropTypes.bool.isRequired
  }).isRequired
};

export default InputContainer;
